import { z } from 'zod';

import { DOCUMENT_STATUSES } from '@/lib/document-status';

import { avatarColorIndex } from '@/components/ui/avatar';

// Contrato del listado enriquecido validado con Zod (ENG-VAL-01): un drift del
// backend (norms:null, status fuera de la unión, campo faltante) se detecta acá
// y cae al estado de error de la query, en vez de reventar en render.

export const masterListNormSchema = z.object({
  id: z.string(),
  normCode: z.string(),
  clause: z.string(),
});

export const masterListResponsibleSchema = z.object({
  userId: z.string(),
  displayName: z.string(),
  initials: z.string(),
});

export const masterListRowSchema = z.object({
  id: z.string(),
  code: z.string(),
  title: z.string().nullable(),
  status: z.enum(DOCUMENT_STATUSES),
  origin: z.string(),
  version: z.number().nullable(),
  documentType: z.object({ id: z.string(), name: z.string() }),
  processArea: z.object({ id: z.string(), name: z.string() }),
  norms: z.array(masterListNormSchema),
  responsible: masterListResponsibleSchema.nullable(),
  // Dueño de proceso (G3-3); un API anterior sin el campo queda sin asignar.
  owner: masterListResponsibleSchema.nullable().default(null),
  nextReviewAt: z.string().nullable(),
  createdAt: z.string(),
  approvedAt: z.string().nullable(),
  effectiveDate: z.string().nullable(),
  reviewFrequencyDays: z.number().int().nullable(),
  related: z.object({ count: z.number().int().nonnegative(), codes: z.array(z.string()) }),
  // Campos propios (QA F1 #14); un API anterior sin el campo queda en vacío.
  customFields: z.record(z.string(), z.unknown()).default({}),
  // G4: capacitación abierta (estado derivado "En capacitación").
  inTraining: z.boolean().default(false),
});

/** Columna de campo propio definida por la empresa activa. */
export const customFieldColumnSchema = z.object({
  key: z.string(),
  label: z.string(),
  dataType: z.string(),
});
export type CustomFieldColumn = z.infer<typeof customFieldColumnSchema>;

export const masterListResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(masterListRowSchema),
  meta: z.object({
    total: z.number(),
    page: z.number(),
    pageSize: z.number(),
    customFieldColumns: z.array(customFieldColumnSchema).default([]),
  }),
});

export type MasterListNorm = z.infer<typeof masterListNormSchema>;
export type MasterListResponsible = z.infer<typeof masterListResponsibleSchema>;
export type MasterListRow = z.infer<typeof masterListRowSchema>;
export type MasterListResponse = z.infer<typeof masterListResponseSchema>;

/** Índice de color de persona estable (1..8) derivado del userId. */
export function personColorIndex(userId: string): number {
  return avatarColorIndex(userId);
}
